import {
  FETCH_ENROLLMENT_HISTORY_PENDING,
  FETCH_ENROLLMENT_HISTORY,
  FETCH_ENROLLMENT_HISTORY_ERROR
} from "../action/fetchEnrollmentHistoryData";

const initialState = {
  pending: false,
  learnersEnrollmentHistory: [],
  error: null
};
   
const learnersEnrollmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ENROLLMENT_HISTORY_PENDING:
      return {
        ...state,
        pending: true
      };
    case FETCH_ENROLLMENT_HISTORY:
      return {
        ...state,
        pending: false,
        err: false,
        learnersEnrollmentHistory: action.payload
      };
    case FETCH_ENROLLMENT_HISTORY_ERROR:
      return {
        ...state,
        pending: false,
        err: true,
        error: action.error
      };
    default:
      return state;
  }
};
export default learnersEnrollmentReducer;

export const getLearnersEnrollmentHistory = state => state.learnersEnrollmentHistory;
export const getLearnersEnrollmentHistoryPending = state => state.pending;
export const getLearnersEnrollmentHistoryError = state => state.error;
   